import { useEffect, useState } from "react";
import { Users, DollarSign, Image as ImageIcon, Trophy, Clock } from "lucide-react";
import { api, brl } from "../../lib/api";

const Kpi = ({ icon: Icon, label, value, testId, accent }) => (
  <div className="glass rounded-xl p-6" data-testid={testId}>
    <Icon className={`h-5 w-5 ${accent}`} />
    <p className="mt-4 font-display text-4xl font-black">{value}</p>
    <p className="font-mono-tech text-[11px] uppercase tracking-widest text-slate-500">{label}</p>
  </div>
);

export const AdminOverview = ({ onGo }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return <div className="h-40 animate-pulse rounded-xl bg-white/5" />;
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
        <Kpi icon={DollarSign} label="Receita" value={brl(s.revenue)} testId="admin-kpi-revenue" accent="text-lime-300" />
        <Kpi icon={Users} label="Usuários" value={s.users} testId="admin-kpi-users" accent="text-cyan-300" />
        <Kpi icon={ImageIcon} label="Fotos" value={s.photos} testId="admin-kpi-photos" accent="text-cyan-300" />
        <Kpi icon={Trophy} label="Concursos ativos" value={s.active_contests} testId="admin-kpi-contests" accent="text-cyan-300" />
        <button onClick={() => onGo("moderation")} className="text-left" data-testid="admin-kpi-pending">
          <Kpi icon={Clock} label="Aguardando moderação" value={s.pending} accent="text-yellow-300" />
        </button>
      </div>
      <div className="glass overflow-x-auto rounded-xl" data-testid="admin-recent-transactions">
        <p className="border-b border-white/10 px-6 py-4 font-display text-xl font-bold uppercase">Pagamentos recentes</p>
        {s.recent_transactions.length === 0 && <p className="p-6 text-sm text-slate-400">Nenhum pagamento ainda.</p>}
        {s.recent_transactions.map((t) => (
          <div key={t.id} className="grid grid-cols-2 gap-2 border-b border-white/5 px-6 py-3 text-sm last:border-0 md:grid-cols-5">
            <span className="truncate">{t.user_email}</span>
            <span className="truncate text-slate-400">{t.description}</span>
            <span className="font-mono-tech text-xs text-slate-500">{t.provider === "stripe" ? "Stripe" : "Mercado Pago"}</span>
            <span className={`font-mono-tech text-xs ${t.payment_status === "paid" ? "text-lime-300" : "text-yellow-300"}`}>{t.payment_status === "paid" ? "Pago" : "Pendente"}</span>
            <b>{brl(t.amount)}</b>
          </div>
        ))}
      </div>
    </div>
  );
};
